/**
 * index.tsx
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 개요, 분양, 입지, 단지, 세대에 표출되는 우측 사이드 네비게이션 목록을 렌더링하는 컴포넌트
 *
 * -----------------------------------------------------------------------------------------------
 */

import { useState, useEffect } from 'react';
import './index.scss';

import { Link, Element as OriginElement } from 'react-scroll';

interface Props {
  sidebarList: Array<{
    name: string;
    isActive: boolean;
  }>;
}

interface IElement {
  name: string;
  children: React.ReactNode;
}

export const Element = ({ name, children }: IElement) => {
  return (
    <OriginElement name={name} className={'anchor-element'}>
      {children}
    </OriginElement>
  );
};

const SidebarScroll = ({ sidebarList }: Props) => {
  const [isAbsolute, setIsAbsolute] = useState(false);

  const changePosition = () => {
    const fixedTab2 = document.getElementById('fixedTab2');

    if (fixedTab2) {
      const isIncluds = fixedTab2.classList.contains('active-use-sticky');

      if (window.scrollY > 1) {
        setIsAbsolute(isIncluds);
      }
    }
  };

  useEffect(() => {
    setIsAbsolute(false);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      changePosition();
    });
  }, []);

  useEffect(() => {
    const isTouched = document.getElementById('fixedTab2')?.classList.contains('active-use-sticky');
    const linkSideBar = document.getElementsByClassName('linkSidebar');

    let alreadyActive = false;
    for (let i = 0; i < linkSideBar.length; i++) {
      if (linkSideBar[i].classList.contains('linkActive')) {
        alreadyActive = true;

        return;
      } else {
        alreadyActive = false;
      }
    }

    if (isTouched && !alreadyActive) {
      linkSideBar[0].classList.add('linkActive');
    } else {
      linkSideBar[0].classList.remove('linkActive');
    }
  });

  return (
    <>
      <div className={`sidebar-scroll ${isAbsolute ? 'active' : ''}`}>
      {sidebarList.map(({ name, isActive }) => {
          if (isActive) {
            return (
              <div key={name} className="items" id={name}>
                <div className="sidebar-scroll-title">
                  <Link
                    activeClass="linkActive"
                    className="linkSidebar"
                    offset={-70}
                    to={name}
                    spy={true}
                    smooth={true}
                    duration={500}>
                    {name}
                  </Link>
                  <div className="circle-outline">
                    <div className="circle"></div>
                  </div>
                </div>
              </div>
            );
          }
        })}
      </div>
    </>
  );
};

export default SidebarScroll;
